import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Button, Checkbox } from 'antd';
import moment from 'moment';

const TABLE_BORDER = '1px solid #0000004a';

const styles = (theme) => ({
  tableGridWrapper: {
    backgroundColor: 'gray',
  },
  tableGrid: {
    display: 'grid',
    marginTop: '20px',
    marginBottom: '20px',
    backgroundColor: 'white',
  },
  divider: {
    gridColumn: '1 / -1',
    borderBottom: TABLE_BORDER,
    width: '100%',
  },
});

const SETaskRevisionModalV2 = ({
  classes,
  visible,
  onSubmit,
  onCancel,
  data,
  renderHeader = () => (
    <div>
      Making this change would also impact the following deadlines. Please select the changes that
      you want to make along with this{' '}
    </div>
  ),
  columns = ['', 'S.N.', 'Task', 'Previous', 'Updated'],
  title = 'Deadline Change',
}: {
  [key: string]: any;
}) => {
  const tasks = [...data];
  const [checkedItems, setCheckedItems] = React.useState(tasks.map((_) => true));
  const handleCancel = () => onCancel();
  const handleSubmit = async () => {
    const tasksToUpdate = Object.keys(checkedItems)
      .filter((idx) => checkedItems[idx])
      .map((idx) => tasks[idx].taskId);
    await onSubmit(tasksToUpdate);
  };

  const Divider = () => <div className={classes.divider} />;

  const renderModalFooter = () => {
    return (
      <>
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button type="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </>
    );
  };

  const TableCell = ({
    children,
    leftBoundary = false,
    topBoundary = false,
    rightBoundary = false,
  }) => {
    return (
      <span
        style={{
          padding: '10px',
          borderLeft: leftBoundary ? TABLE_BORDER : '',
          borderRight: rightBoundary ? TABLE_BORDER : '',
          backgroundColor: topBoundary ? 'rgba(128, 128, 128, 0.17)' : 'white',
        }}
      >
        {' '}
        {children}{' '}
      </span>
    );
  };

  const FieldCheckbox = ({ index }) => {
    return (
      <Checkbox
        style={{
          padding: '10px',
          borderLeft: TABLE_BORDER,
        }}
        checked={checkedItems[index]}
        onChange={(e) =>
          setCheckedItems({
            ...checkedItems,
            [index]: e.target.checked,
          })
        }
      />
    );
  };

  const TableTitles = () => {
    return (
      <>
        <Divider />
        {columns.map((col, idxC) => (
          <TableCell
            leftBoundary={idxC === 0}
            topBoundary
            rightBoundary={idxC + 1 === columns.length}
          >
            {col}
          </TableCell>
        ))}
        <Divider />
      </>
    );
  };

  const TableRows = () => {
    const EpochDate = (epoch) => (epoch ? moment(epoch).format('DD MMM YYYY | hh:mm A') : '-');
    return (
      <>
        {tasks.map((task, idxR) => {
          return (
            <>
              <FieldCheckbox index={idxR} />
              <TableCell> {idxR + 1} </TableCell>
              <TableCell> {task.name} </TableCell>
              <TableCell> {EpochDate(task.oldDeadline)} </TableCell>
              <TableCell rightBoundary> {EpochDate(task.deadline)} </TableCell>
              <Divider />
            </>
          );
        })}
      </>
    );
  };

  const ComparisonTable = () => {
    return (
      <div className={classes.tableGridWrapper}>
        <div
          className={classes.tableGrid}
          style={{ gridTemplateColumns: `repeat(${columns.length}, auto)` }}
        >
          <TableTitles />
          <TableRows />
        </div>
      </div>
    );
  };

  return (
    <div>
      <Modal
        width="50%"
        visible={visible}
        onCancel={handleCancel}
        onOk={handleSubmit}
        title={title}
        footer={renderModalFooter()}
      >
        {renderHeader()}
        <ComparisonTable />
      </Modal>
    </div>
  );
};

export default React.memo(injectSheet(styles)(SETaskRevisionModalV2));
